"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var function_1 = require("./function");
var Ops = /** @class */ (function () {
    function Ops() {
    }
    Ops.prototype.applyFirst = function (apply) {
        return function (fa) { return function (fb) { return apply.ap(apply.map(function (a) { return function_1.constant(a); }, fa), fb); }; };
    };
    Ops.prototype.applySecond = function (apply) {
        return function (fa) { return function (fb) { return apply.ap(apply.map(function () { return function_1.identity; }, fa), fb); }; };
    };
    Ops.prototype.liftA2 = function (apply) {
        return function (f) { return function (fa) { return function (fb) { return apply.ap(apply.map(f, fa), fb); }; }; };
    };
    Ops.prototype.liftA3 = function (apply) {
        return function (f) { return function (fa) { return function (fb) { return function (fc) { return apply.ap(apply.ap(apply.map(f, fa), fb), fc); }; }; }; };
    };
    Ops.prototype.liftA4 = function (apply) {
        return function (f) { return function (fa) { return function (fb) { return function (fc) { return function (fd) { return apply.ap(apply.ap(apply.ap(apply.map(f, fa), fb), fc), fd); }; }; }; }; };
    };
    return Ops;
}());
exports.Ops = Ops;
var ops = new Ops();
exports.applyFirst = ops.applyFirst;
exports.applySecond = ops.applySecond;
exports.liftA2 = ops.liftA2;
exports.liftA3 = ops.liftA3;
exports.liftA4 = ops.liftA4;
//# sourceMappingURL=Apply.js.map